module.exports = __webpack_public_path__ + "media/images/resources-home-35d5dc55bba002d45aca06c04fb28f8b.svg";